export const fbCss = `
:root {
  --fbp-text: #111827;
  --fbp-text-muted: #6b7280;
  --fbp-border: #e5e7eb;
  --fbp-bg: #ffffff;
  --fbp-bg-soft: rgba(0,0,0,0.03);
  --fbp-link: #2563eb;
}
.dark :root {
  --fbp-text: #e5e7eb;
  --fbp-text-muted: #9ca3af;
  --fbp-border: #262626;
  --fbp-bg: #0a0a0a;
  --fbp-bg-soft: rgba(255,255,255,0.06);
  --fbp-link: #60a5fa;
}

/* Layout */
.fbp-container {
  max-width: 672px; /* roughly max-w-2xl */
  margin: 0 auto;
  padding: 24px 16px;
}

.fbp-card {
  background: var(--fbp-bg);
  border: 1px solid var(--fbp-border);
  color: var(--fbp-text);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.06);
  overflow: hidden;
}

/* Header */
.fbp-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 20px 12px 20px;
}

.fbp-avatar {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  object-fit: cover;
  flex: 0 0 auto;
}

.fbp-header-main {
  min-width: 0;
  flex: 1 1 auto;
}

.fbp-profile-line {
  display: flex;
  align-items: center;
  gap: 6px;
}

.fbp-profile-name {
  font-weight: 600;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fbp-profile-name:hover { text-decoration: underline; }

.fbp-subline {
  margin-top: 2px;
  font-size: 12px;
  color: var(--fbp-text-muted);
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.fbp-icon-geo {
  width: 16px;
  height: 16px;
}

/* More button */
.fbp-more {
  border: 0;
  background: transparent;
  border-radius: 999px;
  padding: 8px;
  cursor: pointer;
}
.fbp-more:hover {
  background: var(--fbp-bg-soft);
}
.fbp-more-icon {
  width: 20px;
  height: 20px;
  fill: currentColor;
  color: var(--fbp-text-muted);
}

/* Body */
.fbp-body {
  padding: 0 20px 12px 20px;
  line-height: 1.35;
  white-space: pre-line; /* respect newlines */
  word-wrap: break-word;
}

.fbp-link {
  color: var(--fbp-link);
  text-decoration: none;
}
.fbp-link:hover { text-decoration: underline; }

/* Mentions / Hashtags */
.fbp-mentions {
  padding: 0 20px 6px 20px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.fbp-mention {
  color: var(--fbp-link);
  cursor: pointer;
}
.fbp-mention:hover { text-decoration: underline; }

.fbp-hashtags {
  padding: 0 20px 8px 20px;
  font-size: 14px;
  color: var(--fbp-text-muted);
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

/* Media */
.fbp-image-wrap {
  background: var(--fbp-bg-soft);
}
.fbp-image {
  display: block;
  width: 100%;
  max-height: 520px;
  object-fit: cover;
}
@media (min-width: 640px) {
  .fbp-image {
    object-fit: contain;
  }
}

/* Link card */
.fbp-link-card {
  display: block;
  margin: 16px 20px 20px 20px;
  border: 1px solid var(--fbp-border);
  border-radius: 12px;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  transition: background 120ms ease;
}
.fbp-link-card:hover {
  background: var(--fbp-bg-soft);
}

.fbp-link-card-media {
  width: 100%;
  height: 208px; /* ~h-52 */
  background: #f3f4f6; /* light neutral */
}
@media (min-width: 640px) {
  .fbp-link-card-media { height: 256px; } /* ~h-64 */
}
.fbp-link-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.fbp-link-card-body {
  padding: 12px 16px;
}
.fbp-link-card-domain {
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.04em;
  color: var(--fbp-text-muted);
}
.fbp-link-card-title {
  margin-top: 4px;
  font-weight: 600;
  line-height: 1.25;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.fbp-link-card-desc {
  margin-top: 6px;
  font-size: 14px;
  color: var(--fbp-text-muted);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Counters */
.fbp-counters {
  padding: 8px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: var(--fbp-text-muted);
}
.fbp-counters-left {
  display: flex;
  align-items: center;
}
.fbp-reaction-bg {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px; height: 20px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 0 0 1px #fff;
}
.dark .fbp-reaction-bg {
  background: #0a0a0a;
  box-shadow: 0 0 0 1px #0a0a0a;
}
.fbp-reaction { display: block; }
.fbp-reaction-inline {
  margin-left: -2px;
  display: inline-block;
}
.fbp-like-count { margin-left: 8px; }

.fbp-counters-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Divider */
.fbp-divider {
  border: 0;
  border-top: 1px solid var(--fbp-border);
  margin: 0;
}

/* Optional: “FB action” look-alike button helpers if needed later */
.fb-text        { color: #65676B; }
.dark .fb-text  { color: #B0B3B8; }
.fb-hover       { background: #F0F2F5; }
.dark .fb-hover { background: #3A3B3C; }

.fb-action {
  height: 36px;
  border-radius: 8px;
  font-size: 15px;
  line-height: 1;
}

.is-liked {
  color: #2078F4;
  background: #E7F3FF;
}
.dark .is-liked { background: rgba(32,120,244,0.15); }

.fb-icon { width: 20px; height: 20px; }

.fb-active { background:#E4E6EB }
.dark .fb-active { background:#4E4F50 }
`;
